const linkWrapper = Array.from(document.querySelectorAll(".reservation-link"));

  linkWrapper.forEach((element) => {
    element.addEventListener('click', () => calenderModalOpen(element));
    console.log(element.dataset.id);
    const modal = document.querySelector(`#${element?.dataset.id}`);
    if (modal.querySelector(".reservation-calender__bg")) {
      modal.querySelector(".reservation-calender__bg").addEventListener('click', () => calenderModalClose(element));
    }
  });

  function calenderModalOpen(element) {
    const reservationLink = element;
    if (reservationLink) {
      const calenderModal = document.querySelector(`#${reservationLink?.dataset.id}`);
      if (reservationLink && calenderModal) {
        calenderModal.style.display = 'block';
        document.body.style.overflow = 'hidden';
      }
    }
  }

  function calenderModalClose (element) {
    const target = element;
    if (target) {
      const calenderModal = document.querySelector(`#${target.dataset.id}`);
      const calenderModalBg = calenderModal.querySelector(".reservation-calender__bg");
      if (calenderModalBg) {
        calenderModal.style.display = 'none';
        document.body.style.overflow = '';
      }
    }
  }